<template>
  <section class="storefinder-block-searchresult-item-more p-t-12">
    <VLazyImage
      v-if="photo"
      class="w-100"
      :src="photo || ''"
      style="aspect-ratio: 5/4; object-fit: cover"
    />
    <div class="d-flex justify-content-between m-t-12">
      <div
        v-if="showStreetViewButton"
        class="-blue -clickable -underline-hover"
        @click="$emit('on-streetview-toggle')"
      >
        {{ streetViewEnabled ? "Close street view" : "Open street view" }}
      </div>
      <div else />
      <div>
        <a
          class="-blue -clickable -ellipsis"
          target="_blank"
          :href="`https://www.google.com/maps?saddr=My+Location&daddr=${latLng.lat},${latLng.lng}`"
          >{{ insertString("FindStore", "CalculateRoute") }}</a
        >
      </div>
    </div>
    <div class="storefinder-block-opendata m-t-12">
      <StoreOpeningHours
        v-if="store.Model.OpeningHours && store.Model.OpeningHours.length"
        :model="store.Model.OpeningHours"
        class="m-t-12"
      />
      <div v-else-if="store.openData">
        <div
          v-for="(day, windex) in store.openData"
          :key="windex"
          v-html="day"
        />
      </div>
    </div>
    <div class="m-t-12">
      <!-- <div v-if="store.Model.Email && !dealer">
        <span>{{ insertString("Global", "EmailLabel") }}: </span
        ><a class="-blue -clickable" :href="`mailto:${store.Model.Email}`">{{
          store.Model.Email
        }}</a>
      </div> -->
      <div v-if="phone">
        <span>{{ insertString("GenericForm", "PhoneLabel") }}: </span
        ><a class="-blue -clickable" :href="`tel::${phone}`">{{ phone }}</a>
      </div>
    </div>
  </section>
</template>
<script>
import VLazyImage from 'v-lazy-image';
import StoreOpeningHours from '@/Scripts/components/pages/FindStore/StoreOpeningHours.vue';
export default {
  components: {
    VLazyImage,
    StoreOpeningHours
  },
  props: {
    store: Object,
    photo: String,
    streetViewEnabled: Boolean
  },
  computed: {

    latLng () {
      if (this.store.placeData && this.store.placeData.geometry && this.store.placeData.geometry.location) {
        return { lat: this.store.placeData.geometry.location.lat(), lng: this.store.placeData.geometry.location.lng() };
      } else {
        return { lat: this.store.Coordinate.Latitude, lng: this.store.Coordinate.Longitude };
      }
    },
    showStreetViewButton () {
      if (!this.store.StreetView) {
        return true;
      }
      return this.store.StreetView.Enabled;
    },
    dealer () {
      return this.store.Model.Type === 'Dealer';
    },
    phone () {
      if (this.dealer && !this.store.Model.Phone) {
        return this.store.Model.formattedPhoneNumber;
      }
      return this.store.Model.Phone;
    }
  }
};
</script>
